import   React              , { Component } from "react"                                   ;
import { observer } from "mobx-react";

import { modquizPaths } from "../../../index";

import {
    ObjectList,
    ObjectCard,
    ObjectBlock,
} from "../../../Component/ObjectListAndDetail";
import { Link } from "react-router-dom";
import { QuizObject          }              from "../../../../../store/modquiz/quiz_objects/quiz-object";

type ObjectGalleryItemProps = {
    quiz_object: QuizObject,
    subject_slug: string,
    object_key: string,
    openEditObjectModal: Function,
    removeSubjectObject: Function
};

function ObjectGalleryItem({ quiz_object, subject_slug, object_key, openEditObjectModal, removeSubjectObject }: ObjectGalleryItemProps) {
    var link_url = modquizPaths.quizObject(subject_slug, quiz_object._id);
    
    return (
        <Link to={link_url} key={object_key}>
            <ObjectBlock
                action={() => openEditObjectModal(quiz_object)}
            >
                <ObjectCard
                    key={quiz_object._id}
                    title={quiz_object.title}
                    definition={quiz_object.definition}
                    active={quiz_object.active}
                    score={quiz_object.tracking.quiz_object}
                    remove={() =>
                        removeSubjectObject(quiz_object.slug)
                    }
                />
            </ObjectBlock>
        </Link>
    );

}

type ObjectGalleryProps = {
    quiz_objects: Map<string, QuizObject>
    subject_slug: string,
    openEditObjectModal: Function,
    removeSubjectObject: Function,
    emptyComponent: JSX.Element
};

const ObjectGallery = observer(({ quiz_objects, subject_slug, openEditObjectModal, removeSubjectObject, emptyComponent }: ObjectGalleryProps) => {
    if (!quiz_objects || quiz_objects.size == 0) {
        return emptyComponent;

    }
    
    let galleryItems: Array<JSX.Element> = [];

    quiz_objects.forEach((quiz_object: QuizObject, object_key: string) => {
        galleryItems.push(<ObjectGalleryItem openEditObjectModal={openEditObjectModal} removeSubjectObject={removeSubjectObject} subject_slug={subject_slug} quiz_object={quiz_object} object_key={object_key} />);
    });

    var html = (
        <div>
            <ObjectList quizObjects={galleryItems} />
        </div>
    );

    return html
});


    

export default ObjectGallery